import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { AuthService } from './auth.service';
import { AlertService } from '../../shared/alert/services/alert.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private alertService: AlertService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    let isAuth = this.authService.isAuthFromLocalStorage();
    if (!isAuth) {
        return false;
    }

    if (!this.hasValidRole(route, this.authService.userRolesFromLocalStorage())) {
      this.alertService.add('danger', 'You do not have permission to access this module');
      window.location.href = '/';
      return false;
    }

    if (!this.hasValidLanguage()) {
      this.alertService.add('danger', 'You do not have permission to access this module in this language');
      window.location.href = '/';
      return false;
    }
    
    return true;
  }

  hasValidRole(route, userRoles) {
    let roles = route.data["roles"] as Array<string>;

    if (roles.length == 0) {
      return true;
    }

    for (var i = 0; i < roles.length; i++) {
      for (var j = 0; j < userRoles.length; j++) {
        if (roles[i] == userRoles[j]) {
          return true;
        }
      }
    }

    return false;
  }

  hasValidLanguage() {
    var allowedLanguages = this.authService.getUserLanguages().map(x => x.languageId);
    var currentLanguage = this.authService.getActualLanguage().languageId;

    var result = this.arrayIncludes(allowedLanguages, currentLanguage);
    return result;
  }

  arrayIncludes(list, item) {
    var i = list.length;
    while (i--) {
      if (list[i].toLowerCase() === item.toLowerCase()) {
        return true;
      }
    }
    return false;
  };
}



// WEBPACK FOOTER //
// ./src/app/authentication/services/auth.guard.service.ts